import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.regexp.match.js";
//
//
//
//
//
//
//
//
//
import Account from "./store/models/Account";
import Timer from "./store/models/Timer";
import Entry from "./store/models/Entry";
import EntrySuggestion from "./store/models/EntrySuggestion";
import TimerTag from "./store/models/TimerTag";
import EntryTag from "./store/models/EntryTag";
import User from "./store/models/User";
import Client from "./store/models/Client";
import Project from "./store/models/Project";
import Budget from "./store/models/Budget";
import Group from "./store/models/Group";
import PhaseCategory from "./store/models/PhaseCategory";
import Tag from "./store/models/Tag";
import TagList from "./store/models/TagList";
import Todo from 'src/store/models/Todo';
import TodoList from 'src/store/models/TodoList';
import UserIntegration from 'src/store/models/UserIntegration';
import ApprovalRequest from 'src/store/models/ApprovalRequest';
import AccountFeature from 'src/store/models/AccountFeature';
import moment from 'moment';
import { map } from 'lodash';
import { abridgedDataUtils } from 'src/mixins/abridged-data-utils';
import ProjectTag from 'src/store/models/ProjectTag';
import ProjectTagList from 'src/store/models/ProjectTagList';
import Notify from 'quasar/src/plugins/Notify.js';;
import Maintenance from "./pages/Maintenance.vue";
export default {
  name: 'App',
  metaInfo: {
    title: 'Timeneye',
    titleTemplate: '%s - Timeneye'
  },
  mixins: [abridgedDataUtils],
  components: {
    MaintenancePage: Maintenance
  },
  watch: {
    me: function me(nextVal, prevVal) {
      if (!prevVal && nextVal) {
        this.changeLanguage(nextVal.settings.appLanguage);

        if (nextVal.environment === 'track' && nextVal.uniq_id) {
          window.location.href = process.env.TRACK_URL + '/dashboard?uniqId=' + nextVal.uniq_id;
        } // initialize third party services


        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          this.initGoogleAnalytics(nextVal);
        }

        this.initHubspot(nextVal);
        this.initClarity(nextVal);
        this.initCanny(nextVal); // fetch initial data from server & setup websockets

        this.getData();
        Timer.updateRunningTimer();
        this.initPusherConnection(nextVal.user_id);
      }
    }
  },
  computed: {
    maintenanceEnd: function maintenanceEnd() {
      return this.$store.state.app.maintenanceEnd;
    }
  },
  methods: {
    calculateVh: function calculateVh() {
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh + 'px');
    },
    initGoogleAnalytics: function initGoogleAnalytics(user) {
      if (this.$gtag) {
        this.$gtag.query('get', process.env.GOOGLE_ANALYTICS_ID, 'client_id', function (clientId) {
          if (clientId && user.client_id !== clientId) {
            // send client_id to the server
            User.$updateMe({
              client_id: clientId
            }).catch(function () {});
          }
        });
        this.$gtag.config({
          user_id: user.user_id
        });
        this.$gtag.customMap({
          dimension1: 'is_trial',
          dimension2: 'billing_enabled',
          dimension3: 'role',
          dimension4: 'account_id',
          dimension5: 'app_user_id',
          dimension6: 'target_users',
          dimension7: 'preferred_features',
          dimension8: 'preferred_integrations',
          dimension9: 'google_user',
          dimension10: 'microsoft_user',
          dimension11: 'environment'
        });
        this.$gtag.customMap({
          metric1: 'health_score',
          metric2: 'account_health_score',
          metric3: 'users_count'
        });
        this.$gtag.set({
          user_properties: {
            app_user_id: user.user_id,
            account_id: user.account_id,
            is_trial: user.account ? user.account.is_trial : false,
            billing_enabled: user.account ? user.account.billing_enabled : false,
            target_users: user.account ? user.account.users_invite_target : 0,
            preferred_integrations: Array.isArray(user.setup_integrations) ? user.setup_integrations.join(';') : '',
            preferred_features: user.account && Array.isArray(user.account.setup_features) ? user.account.setup_features.join(';') : '',
            google_user: !!user.is_google,
            microsoft_user: !!user.is_microsoft,
            environment: user.environment,
            role: user.is_owner ? this.$t('roles.description.owner') : user.is_admin ? this.$t('roles.description.admin') : this.$tc('general.user', 1)
          }
        });
        var data = {
          health_score: user.health_score,
          account_health_score: user.account ? user.account.health_score : null,
          users_count: user.account ? user.account.users_count : null
        };

        if (process.env.GOOGLE_ANALYTICS_DEBUGMODE) {
          data.debug_mode = true;
        }

        this.$gtag.event('user_data', data);
      }
    },
    initHubspot: function initHubspot(user) {
      if (user) {
        if (user.hubspot_visitor_identification_token) {
          window.hsConversationsSettings = {
            loadImmediately: false,
            identificationEmail: user.email,
            identificationToken: user.hubspot_visitor_identification_token
          };
        } else {
          // identify user in hubspot for safety
          window._hsq.push(['identify', {
            email: user.email
          }]);
        }

        if (!this.isMobile) {
          if (window.HubSpotConversations) {
            setTimeout(function () {
              window.HubSpotConversations.widget.load();
            }, 4000);
          } else {
            window.hsConversationsOnReady = [function () {
              window.HubSpotConversations.widget.load();
            }];
          }
        }
      } else {
        window.hsConversationsSettings = {
          loadImmediately: false
        };
      }
    },
    initClarity: function initClarity(user) {
      if (user.user_id && user.account.is_trial && moment().diff(moment(user.created_date), 'days') < 7 && window.clarity) {
        window.clarity('consent');
        window.clarity('identify', "".concat(user.user_id));
        window.clarity('set', 'teuserid', "".concat(user.user_id));
      } else if (window.clarity) {
        window.clarity('stop');
      }
    },
    initCanny: function initCanny(user) {
      if (window.Canny) {
        var _user$avatar;

        var accountData = {};

        if (user.account) {
          accountData.id = user.account_id; // eslint-disable-line

          accountData.name = user.account.account_name; // eslint-disable-line
          //

          accountData.created = moment.utc(user.account.created_date).toISOString(); // eslint-disable-line
        }

        window.Canny('identify', {
          appID: process.env.CANNY_APP_ID,
          user: {
            email: user.email,
            name: user.name,
            companies: [accountData],
            id: user.user_id,
            avatarURL: (_user$avatar = user.avatar) === null || _user$avatar === void 0 ? void 0 : _user$avatar.avatar_url,
            // eslint-disable-line
            created: moment.utc(user.created_date).toISOString()
          }
        });
      }
    },
    initPusherConnection: function initPusherConnection(userId) {
      var _this = this;

      var focused = function focused() {
        var currentTime = moment();
        var state = _this.$echo.connector.pusher.connection.state; // if the app was offline, or if the app was inactive for more than 2 hours, reconnect the pusher connection

        if (_this.$store.state.app.wasOffline && window.navigator.onLine || currentTime.isAfter(moment(_this.$store.state.app.lastFocusedTime).add(2, 'hours'))) {
          _this.$store.commit('app/setWasOffline', false);

          _this.restartPusherConnection(userId); // if we have been offline for more than 5 minutes, refresh the dashboard and fetch new abridged data


          if (currentTime.isAfter(moment(_this.$store.state.app.lastFocusedTime).add(5, 'minutes'))) {
            _this.$root.$emit('refresh-calendar');

            _this.getData();
          } // otherwise reconnect the pusher connection if not connected

        } else if (state !== 'connected' && state !== 'connecting') {
          _this.restartPusherConnection(userId);
        }

        _this.$store.commit('app/setLastFocusedTime', currentTime.valueOf());
      };

      var internetWasOffline = function internetWasOffline() {
        _this.$store.commit('app/setWasOffline', true);
      };

      window.addEventListener('offline', internetWasOffline);
      window.addEventListener('focus', focused);
      this.openPusherConnection(userId);
    },
    openPusherConnection: function openPusherConnection(userId) {
      var _this2 = this;

      // Setup sockets callbacks
      this.$echo.private("App.User.".concat(userId)).listen('AccountUpdated', function (_ref) {
        var account = _ref.account;
        // Delete features that are not available anymore
        var availableFeatureCodes = account.features.map(function (feature) {
          return feature.code;
        });
        AccountFeature.delete(function (accountFeature) {
          return !availableFeatureCodes.includes(accountFeature.feature_code);
        });
        Account.insertOrUpdate({
          data: [account]
        }).then(function () {
          User.refreshMe();

          _this2.$root.$emit('account-updated');
        });
      }).listen('TimerCreated', function (_ref2) {
        var timer = _ref2.timer;
        Timer.insertOrUpdate({
          data: [timer]
        });
      }).listen('TimerUpdated', function (_ref3) {
        var timer = _ref3.timer;

        // update necessary pivot tables
        if (timer && timer.tags.length > 0) {
          TimerTag.delete(map(timer.tags, 'tag_id'));
        } // this where is needed so that the subscribeStoreActions in the Calendar/index.js can properly get any
        // changes to existing timers and repaint the needed cards


        Timer.update({
          where: timer.timer_id,
          data: [timer]
        });
      }).listen('TimerDeleted', function (_ref4) {
        var timerId = _ref4.timerId;
        TimerTag.delete(function (timerTag) {
          return timerTag.timer_id === timerId;
        });
        Timer.delete(timerId);
        Timer.$getOldTimersCount();
      }).listen('EntryCreated', function (_ref5) {
        var entry = _ref5.entry;

        _this2.$root.$emit('entry-changed', entry);

        Entry.insertOrUpdate({
          data: [entry]
        });

        if (entry.todo_id) {
          // if the entry is attached to a todo and the todo is already in the store, refetch it
          var todo = Todo.find(entry.todo_id);

          if (todo && (!todo.is_personal || entry.user_id === _this2.me.user_id)) {
            Todo.api().fetchById(entry.todo_id);
          }
        }
      }).listen('EntryUpdated', function (_ref6) {
        var entry = _ref6.entry,
            oldDate = _ref6.oldDate;

        _this2.$root.$emit('entry-changed', entry, oldDate); // update necessary pivot tables


        if (entry.tags && entry.tags.length > 0) {
          EntryTag.delete(map(entry.tags, 'tag_id'));
        }

        Entry.insertOrUpdate({
          data: [entry]
        });

        if (entry.todo_id) {
          // if the entry is attached to a todo and the todo is already in the store, refetch it
          var todo = Todo.find(entry.todo_id);

          if (todo && (!todo.is_personal || entry.user_id === _this2.me.user_id)) {
            Todo.api().fetchById(entry.todo_id);
          }
        }
      }).listen('EntryDeleted', function (_ref7) {
        var entry = _ref7.entry;
        EntryTag.delete(function (entryTag) {
          return entryTag.entry_id === entry.entry_id;
        });
        Entry.delete(entry.entry_id);

        if (entry.todo_id) {
          // if the entry is attached to a todo and the todo is already in the store, refetch it
          var todo = Todo.find(entry.todo_id);

          if (todo && (!todo.is_personal || entry.user_id === _this2.me.user_id)) {
            Todo.api().fetchById(entry.todo_id);
          }
        }

        _this2.$root.$emit('entry-changed', _objectSpread(_objectSpread({}, entry), {}, {
          deleted: true
        }));
      }).listen('EntriesLockStatusChanged', function () {
        _this2.$root.$emit('refresh-calendar');
      }).listen('EntrySuggestionCreated', function (_ref8) {
        var suggestion = _ref8.suggestion;

        if (_this2.isCalendarLoading) {
          _this2.$store.commit('app/setCalendarLoading', {
            calendar: suggestion.source,
            value: false
          });
        }

        _this2.$root.$emit('suggestion-changed', suggestion);

        EntrySuggestion.insertOrUpdate({
          data: [suggestion]
        });
      }).listen('EntrySuggestionUpdated', function (_ref9) {
        var suggestion = _ref9.suggestion;

        _this2.$root.$emit('suggestion-changed', suggestion);

        EntrySuggestion.insertOrUpdate({
          data: [suggestion]
        });
      }).listen('EntrySuggestionDeleted', function (_ref10) {
        var suggestion = _ref10.suggestion;
        EntrySuggestion.delete(suggestion.entry_suggestion_id);

        _this2.$root.$emit('suggestion-changed', suggestion);
      }).listen('RecurrentSuggestionsChanged', function (_ref11) {
        var source = _ref11.source;

        if (_this2.isCalendarLoading) {
          _this2.$store.commit('app/setCalendarLoading', {
            calendar: source,
            value: false
          });
        }

        EntrySuggestion.delete(function (entrySuggestion) {
          return entrySuggestion.source === source && entrySuggestion.type === 'recurrent';
        });

        _this2.$root.$emit('fetch-recurrent-suggestions');
      }).listen('RecurrentSuggestionDeleted', function (_ref12) {
        var recurrentSuggestionId = _ref12.recurrentSuggestionId;
        EntrySuggestion.delete(function (entrySuggestion) {
          return entrySuggestion.repeatable_suggestion_id === parseInt(recurrentSuggestionId);
        });
      }).listen('RecurrentInstanceDeleted', function (_ref13) {
        var suggestionId = _ref13.suggestionId;
        EntrySuggestion.delete(function (entrySuggestion) {
          return entrySuggestion.entry_suggestion_id === parseInt(suggestionId);
        });
      }).listen('UserCreated', function (_ref14) {
        var user = _ref14.user;
        User.insertOrUpdate({
          data: [user]
        }).then(function () {
          _this2.$root.$emit('refresh-users');
        });
      }).listen('UserDeactivated', function () {
        localStorage.removeItem('access_token');
        window.location = '/login';
      }).listen('UserLogout', function () {
        localStorage.removeItem('access_token');
        if (Date.now() - User.lastLogoutAt < 500) return;

        _this2.$q.notify({
          message: _this2.$t('app.session_expired'),
          color: 'primary',
          timeout: 2000,
          onDismiss: function onDismiss() {
            window.location = '/login';
          }
        });
      }).listen('UserUpdated', function (_ref15) {
        var user = _ref15.user;
        User.insertOrUpdate({
          data: [user]
        }).then(function () {
          _this2.$root.$emit('refresh-users');

          if (user.user_id === _this2.me.user_id) {
            User.refreshMe();
          }
        });
      }).listen('UserDeleted', function (_ref16) {
        var userId = _ref16.userId;
        User.delete(userId).then(function () {
          _this2.$root.$emit('refresh-users');
        });
      }).listen('ClientCreated', function (_ref17) {
        var client = _ref17.client;
        Client.insertOrUpdate({
          data: [client]
        }).then(function () {
          _this2.$root.$emit('refresh-clients');
        });
      }).listen('ClientUpdated', function (_ref18) {
        var client = _ref18.client;
        Client.insertOrUpdate({
          data: [client]
        }).then(function () {
          _this2.$root.$emit('refresh-clients');
        });
      }).listen('ClientDeleted', function (_ref19) {
        var clientId = _ref19.clientId;
        Client.delete(clientId);

        _this2.$root.$emit('refresh-clients');
      }).listen('IntegrationUnlinked', function (_ref20) {
        var integrationCode = _ref20.integrationCode,
            project = _ref20.project;

        if (project) {
          Project.insertOrUpdate({
            data: project
          });
        }

        Todo.delete(function (todo) {
          return todo.integration_code === integrationCode && (!project || todo.project_id === project.project_id);
        });
        TodoList.delete(function (todoList) {
          return todoList.integration_code === integrationCode && (!project || todoList.project_id === project.project_id);
        }); // remove project tags

        ProjectTag.delete(function (projectTag) {
          var tag = Tag.find(projectTag.tag_id);
          return tag.integration_code === integrationCode && (!project || projectTag.project_id === project.project_id);
        });
        ProjectTagList.delete(function (projectTagList) {
          var tagList = TagList.find(projectTagList.tag_list_id);
          return tagList.integration_code === integrationCode && (!project || projectTagList.project_id === project.project_id);
        }); // remove the userIntegration from the store

        UserIntegration.delete(function (userIntegration) {
          return userIntegration.integration_code === integrationCode;
        }); // edit me to remove the integration from the store

        User.refreshMe();

        _this2.$root.$emit('refresh-todos');

        _this2.$root.$emit('reload-tag-lists');
      }).listen('IntegrationSynced', function (_ref21) {
        var integrationCode = _ref21.integrationCode;
        // edit me to add the integration to the store
        User.refreshMe();

        _this2.$root.$emit('refresh-todos');

        _this2.$root.$emit('refresh-todo-lists');
      }).listen('IntegrationUnlinked', function (_ref22) {
        var integrationCode = _ref22.integrationCode,
            project = _ref22.project;
        Todo.delete(function (todo) {
          return todo.integration_code === integrationCode && (!project || todo.project_id === project.project_id);
        });
        TodoList.delete(function (todoList) {
          return todoList.integration_code === integrationCode && (!project || todoList.project_id === project.project_id);
        });

        _this2.$root.$emit('refresh-todos');

        _this2.$root.$emit('refresh-todo-lists');

        _this2.$root.$emit('integration-unlinked', integrationCode);
      }).listen('UserIntegrationUpdated', function (_ref23) {
        var userIntegration = _ref23.userIntegration;
        UserIntegration.insertOrUpdate({
          data: [userIntegration]
        }); // edit me to add the integration to the store

        User.refreshMe();
      }).listen('ProjectCreated', function (_ref24) {
        var project = _ref24.project;
        Project.insertOrUpdate({
          data: [project]
        }).then(function () {
          _this2.$root.$emit('refresh-projects');

          _this2.$root.$emit('refresh-phases');

          _this2.$root.$emit('refresh-users');

          _this2.$root.$emit('refresh-clients');
        });
      }).listen('ProjectUpdated', function (_ref25) {
        var project = _ref25.project;
        // only refresh data if the event has not been dispatched due to a todo sync
        var refreshData = true;
        var oldProject = Project.find(project.project_id); // if we already have the project in the store, and the syncing status has changed (this happens only when
        // we are syncing todos), we don't want to refresh other data since it's not necessary. The refresh events
        // triggers a lot of requests to the server that are not needed since only the syn info are being changed.
        // (we DO NOT change other data if the project is being synced).

        if (oldProject && oldProject.is_syncing !== project.is_syncing) {
          refreshData = false;
        }

        Project.insertOrUpdate({
          data: [project]
        }).then(function () {
          // TODO: update only entries of project. Doing this necessitates a change on how cards in dashboard are
          // generated, since currently they do not rely on the store data to make them "lighter" and faster to load
          if (refreshData) {
            _this2.$root.$emit('refresh-projects');

            _this2.$root.$emit('refresh-phases');

            _this2.$root.$emit('refresh-users');

            _this2.$root.$emit('refresh-clients');

            _this2.$root.$emit('refresh-calendar');
          }
        });
      }).listen('ProjectArchived', function (_ref26) {
        var project = _ref26.project;
        Project.update({
          where: project.project_id,
          data: {
            is_active: 0
          }
        });
      }).listen('ProjectUnarchived', function (_ref27) {
        var project = _ref27.project;
        Project.update({
          where: project.project_id,
          data: {
            is_active: 1
          }
        });
      }).listen('ProjectDeleted', function (_ref28) {
        var projectId = _ref28.projectId;
        Project.delete(projectId);

        _this2.$root.$emit('refresh-projects');

        _this2.$root.$emit('refresh-phases');

        _this2.$root.$emit('refresh-users');

        _this2.$root.$emit('refresh-clients');
      }).listen('GroupCreated', function (_ref29) {
        var group = _ref29.group;
        Group.insertOrUpdate({
          data: [group]
        }).then(function () {
          _this2.$root.$emit('refresh-groups');
        });
      }).listen('GroupUpdated', function (_ref30) {
        var group = _ref30.group;
        Group.insertOrUpdate({
          data: [group]
        }).then(function () {
          _this2.$root.$emit('refresh-groups');
        });
      }).listen('GroupDeleted', function (_ref31) {
        var groupId = _ref31.groupId;
        Group.delete(groupId);

        _this2.$root.$emit('refresh-groups');
      }).listen('PhaseCategoryCreated', function (_ref32) {
        var phaseCategory = _ref32.phaseCategory;
        PhaseCategory.insertOrUpdate({
          data: [phaseCategory]
        }).then(function () {
          _this2.$root.$emit('refresh-categories');
        });
      }).listen('PhaseCategoryUpdated', function (_ref33) {
        var phaseCategory = _ref33.phaseCategory;
        PhaseCategory.insertOrUpdate({
          data: [phaseCategory]
        }).then(function () {
          _this2.$root.$emit('refresh-categories');
        });
      }).listen('PhaseCategoryDeleted', function (_ref34) {
        var phaseCategoryId = _ref34.phaseCategoryId;
        PhaseCategory.delete(phaseCategoryId);

        _this2.$root.$emit('refresh-categories');
      }).listen('BudgetUpdated', function (_ref35) {
        var budget = _ref35.budget;
        Budget.insertOrUpdate({
          data: [budget]
        });
      }).listen('BudgetCreated', function (_ref36) {
        var budget = _ref36.budget;
        Budget.insertOrUpdate({
          data: [budget]
        });
      }).listen('BudgetAlert', function (_ref37) {
        var project = _ref37.project,
            message = _ref37.message;

        _this2.$q.notify({
          message: message,
          color: 'primary',
          html: true,
          timeout: 0,
          actions: [{
            label: _this2.$t('app.go_to_project'),
            color: 'te-azure-dark',
            'no-caps': true,
            handler: function handler() {
              _this2.$router.push('/projects/' + project.project_id);
            }
          }, {
            label: _this2.$t('general.dismiss'),
            color: 'white',
            'no-caps': true,
            handler: function handler() {}
          }]
        });
      }).listen('TagDeleted', function (_ref38) {
        var tagId = _ref38.tagId;
        Tag.delete(tagId);
      }).listen('TagListDeleted', function (_ref39) {
        var tagListId = _ref39.tagListId;
        TagList.delete(tagListId);
      }).listen('TodosSynced', function () {
        _this2.$root.$emit('refresh-todos');
      }).listen('TodoCreated', function () {
        _this2.$root.$emit('refresh-todos');
      }).listen('TodoUpdated', function () {
        _this2.$root.$emit('refresh-todos');
      }).listen('TodoDeleted', function () {
        _this2.$root.$emit('refresh-todos');
      }).listen('TodoListCreated', function (_ref40) {
        var todoList = _ref40.todoList;
        TodoList.insertOrUpdate({
          data: todoList
        });
      }).listen('TodoListUpdated', function (_ref41) {
        var todoList = _ref41.todoList;
        TodoList.insertOrUpdate({
          data: todoList
        });
      }).listen('TodoListDeleted', function (_ref42) {
        var todoListId = _ref42.todoListId;
        TodoList.deleteById(todoListId);
      }).listen('Integrations\\AsyncFailure', function (_ref43) {
        var errorMessage = _ref43.errorMessage,
            errorSlug = _ref43.errorSlug,
            integrationCode = _ref43.integrationCode;
        var notification = {
          message: errorMessage
        };

        if (errorSlug && errorSlug === 'integration.missing-scopes') {
          notification.multiLine = true;
          notification.html = true;
          notification.actions = [{
            label: _this2.$t('app.go_to_integration'),
            color: 'white',
            handler: function handler() {
              // go to the integrations page
              _this2.$router.push({
                path: "integrations/".concat(integrationCode)
              });
            }
          }];
        }

        Notify.create(notification);
      }).listen('ApprovalRequestCreated', function (_ref44) {
        var approvalRequest = _ref44.approvalRequest;

        if (approvalRequest.approval_request_id) {
          var existingApprovalRequest = ApprovalRequest.query().where('approval_request_id', approvalRequest.approval_request_id).first();

          if (existingApprovalRequest) {
            ApprovalRequest.update({
              where: function where(appReq) {
                return appReq.approval_request_id === existingApprovalRequest.approval_request_id;
              },
              data: approvalRequest
            });
          } else {
            ApprovalRequest.insert({
              data: approvalRequest
            });
          }

          _this2.$eventHub.$emit('approval-request-created', approvalRequest);
        }
      }).listen('ApprovalRequestUpdated', function (_ref45) {
        var approvalRequest = _ref45.approvalRequest;

        if (approvalRequest.approval_request_id) {
          var existingApprovalRequest = ApprovalRequest.query().where('approval_request_id', approvalRequest.approval_request_id).first();

          if (existingApprovalRequest) {
            ApprovalRequest.update({
              where: function where(appReq) {
                return appReq.approval_request_id === existingApprovalRequest.approval_request_id;
              },
              data: approvalRequest
            });
          } else {
            ApprovalRequest.insert({
              data: approvalRequest
            });
          }

          _this2.$eventHub.$emit('approval-request-updated', approvalRequest);
        }
      });
    },
    restartPusherConnection: function restartPusherConnection(userId) {
      try {
        this.$echo.leave("App.User.".concat(userId));
      } catch (e) {}

      this.openPusherConnection(userId);
    },
    getData: function getData() {
      if (this.me.is_admin || this.me.is_pm || this.me.is_manager) {
        this.getAbridgedUsers();
      }

      this.getSubscriptionTypes();

      if (this.isSubscribed) {
        if (this.me.is_admin || this.me.is_gm) {
          this.getAbridgedGroups();
        }

        this.getAbridgedProjects();
        this.getAbridgedCategories();

        if (this.me.account.hasFeature('expenses_management')) {
          this.getAbridgedExpenseCategories();
        }

        this.getAbridgedClients();
        this.getAbridgedTags();
        this.getAbridgedIntegrations();
        this.getFeatures();

        if (this.me.account.hasFeature('approval')) {
          this.getAbridgedApprovalRequests();
        }
      }
    },
    checkForNewVersion: function checkForNewVersion() {
      var _this3 = this;

      var gitTag = process.env.CI_COMMIT_TAG;
      var gitSHA = process.env.CI_COMMIT_SHA;
      var randomString = Math.random().toString(36).substring(7);
      this.$axios.get(process.env.APP_URI + '/statics/version.json?q=' + randomString).then(function (response) {
        var maintenanceEnd = response.data.estimated_maintenance_end;

        if (maintenanceEnd) {
          _this3.$store.commit('app/setMaintenanceEnd', maintenanceEnd);

          document.body.classList.remove('is-loading');
        } else {
          _this3.$store.commit('app/setMaintenanceEnd', false);
        }

        var newVersion = response.data.version;

        if (gitTag && gitTag !== newVersion || gitSHA && gitSHA !== newVersion) {
          // Set new version available in the store true
          _this3.$store.commit('app/setNewVersionAvailable', true);
        } else {
          // Set new version available in the store false
          _this3.$store.commit('app/setNewVersionAvailable', false);
        }
      }).catch(function () {});
    },
    initKeyboardShortcuts: function initKeyboardShortcuts() {
      var _this4 = this;

      this.$keyboard.init();
      this.$keyboard.bind('r r', function (params) {
        if (params.target.localName !== 'textarea' && params.target.localName !== 'input' && _this4.$route.matched.some(function (route) {
          return route.meta.shortcut;
        })) {
          _this4.openDialog('RegisterTimeDialog');
        }
      }, 'keyup');
      this.$keyboard.bind('t t', function (params) {
        if (params.target.localName !== 'textarea' && params.target.localName !== 'input' && _this4.$route.matched.some(function (route) {
          return route.meta.shortcut;
        })) {
          _this4.openDialog('TimersDialog');
        }
      }, 'keyup');
      this.$keyboard.bind('e e', function (params) {
        if (params.target.localName !== 'textarea' && params.target.localName !== 'input' && _this4.$route.matched.some(function (route) {
          return route.meta.shortcut;
        })) {
          _this4.openDialog('EntriesDialog');
        }
      }, 'keyup');
    },
    setIconsMappingFunction: function setIconsMappingFunction() {
      this.$q.iconMapFn = function (iconName) {
        // iconName is the content of QIcon "name" prop
        // your custom approach, the following
        // is just an example:
        if (iconName.startsWith('iconeye:') === true) {
          // we strip the "app:" part
          var name = iconName.replace(':', '-');
          return {
            cls: 'iconeye ' + name
          };
        }

        if (iconName.startsWith('fa') === true) {
          var result = iconName.match(/(^fa.?):(.*)/);

          if (result && result.length > 2) {
            // we strip the "app:" part
            return {
              cls: result[1] + ' fa-' + result[2]
            };
          }
        } // when we don't return anything from our
        // iconMapFn, the default Quasar icon mapping
        // takes over

      };
    }
  },
  destroyed: function destroyed() {
    this.$echo.leave("App.User.".concat(this.me.user_id));
  },
  created: function created() {
    var _this5 = this;

    this.calculateVh();
    window.addEventListener('resize', this.calculateVh);
    this.initHubspot(); //

    if (this.isMobile) {
      this.$q.notify.setDefaults({
        position: 'top'
      });
    }

    this.setIconsMappingFunction();
    this.initKeyboardShortcuts(); // Every minute check if there is a new version by downloading the file at the address `${process.env.APP_URI}/version.json`

    var gitTag = process.env.CI_COMMIT_TAG;
    var gitSHA = process.env.CI_COMMIT_SHA;

    if (gitTag || gitSHA) {
      this.checkForNewVersion();
      setInterval(function () {
        _this5.checkForNewVersion();
      }, 300000);
    }
  }
};